import { ActivityDefinitionType, PipelinePhaseType, PipelineStatus } from './enums';
import ActivityEvent from './activityEvent';
import { OrchestrationRouteModel } from './orchestrationRouteModel';
import ReplayedEvents from '@/models/replayedEvents';

export default class ActivityDefinition {
  public activityDefinitionTypeId: number;
  public assemblyName: string;
  public autoReplayTimeout: string;
  public autoReplay: boolean | null;
  public dependencyMap: string;
  public displayToUser: boolean;
  public events: ActivityEvent[];
  public eventsReplayable: boolean;
  public warningCount: number;
  public exceptionCount: number;
  public id: number;
  public internalId: number;
  public isExpanded: boolean;
  public isReplayable: boolean;
  public orchestrationRouteId: number;
  public orchestrationRouteModel: OrchestrationRouteModel | undefined;
  public maxAutoReplayAttempts: number | null;
  public name: string;
  public pipelinePhaseTypeId: number | null;
  public replays: ReplayedEvents[];
  public sequence: number;
  public status: PipelineStatus | null;
  public totalEventCount: number | null;
  public workflowId: number;

  constructor(existingDefinition?: ActivityDefinition) {
    this.activityDefinitionTypeId = existingDefinition?.activityDefinitionTypeId || ActivityDefinitionType.Executable;
    this.assemblyName = existingDefinition?.assemblyName || '';
    this.autoReplay = existingDefinition?.autoReplay || false;
    this.autoReplayTimeout = existingDefinition?.autoReplayTimeout || '';
    this.dependencyMap = existingDefinition?.dependencyMap || '';
    this.displayToUser = existingDefinition?.displayToUser || true;
    this.events = [];
    this.eventsReplayable = existingDefinition?.eventsReplayable || false;
    this.warningCount = existingDefinition?.warningCount || 0;
    this.exceptionCount = existingDefinition?.exceptionCount || 0;
    this.id = existingDefinition?.id || 0;
    this.internalId = Math.floor(Math.random() * 1e10);
    this.isExpanded = false;
    this.isReplayable = existingDefinition?.isReplayable || false;
    this.maxAutoReplayAttempts = existingDefinition?.maxAutoReplayAttempts || null;
    this.name = existingDefinition?.name || '';
    this.orchestrationRouteId = existingDefinition?.orchestrationRouteId || 0;
    this.orchestrationRouteModel = existingDefinition?.orchestrationRouteModel || undefined;
    this.pipelinePhaseTypeId = existingDefinition?.pipelinePhaseTypeId || PipelinePhaseType.Extract;
    this.replays = existingDefinition?.replays || [];
    this.sequence = existingDefinition?.sequence || 0;
    this.status = existingDefinition?.status || null;
    this.totalEventCount = existingDefinition?.totalEventCount || 0;
    this.workflowId = existingDefinition?.workflowId || 0;
  }
}
